import React, { useState, useEffect } from 'react';

import { format } from 'date-fns';
import { NotificationContainer } from 'react-notifications';
import api from '../../services/api';
import PlanManagerContext from './PlanManagerContext';

import NavBar from '../../components/NavBar';
import Loader from '../../components/Loader';
import Error from '../../components/Error';
import Line from '../../components/Line';
import NavTabsGeneral from '../../components/NavTabsGeneral';

import TabInfo from './Tabs/Info';
// import TabImage from './Tabs/Image';
// import TabMedia from './Tabs/Media';

import * as S from './styles';

const PlanManager = props => {
  const [isLoading, setLoading] = useState(true);
  const [isError, setError] = useState(false);
  const [isContent, setContent] = useState(false);
  const [isNewData, setNewData] = useState(false);
  const [objData, setData] = useState({});

  const auxFormatData = data => {
    data.id = data.plaId;
    switch (data.plaStatus) {
      case 0:
        data._plaStatus = 'Active';
        break;
      case 2:
        data._plaStatus = 'Disabled';
        break;
      default:
        data._plaStatus = 'Disabled';
        break;
    }
    // switch (data.plaRecurrence) {
    //   case 'Y':
    //     data._plaRecurrence = 'Yearly';
    //     break;
    //   case 'M':
    //     data._plaRecurrence = 'Monthly';
    //     break;
    //   case 'F':
    //     data._plaRecurrence = 'Free';
    //     break;
    //   default:
    //     // data._plaRecurrence = 'Free';
    //     break;
    // }
    data._plaDateCreated = format(new Date(data.plaDateCreated), 'MM/dd/yyyy');
    data._plaDateUpdated = format(new Date(data.plaDateUpdated), 'MM/dd/yyyy');
    return data;
  };

  useEffect(() => {
    async function loadData() {
      const {
        match: {
          params: { id },
        },
      } = props;

      if (id === 'new') {
        // New Data
        setNewData(true);
        viewContent();
      } else {
        const apiGetData = api('GET', `/plan/${id}`, null);

        const resGetData = await apiGetData;
        const {
          data: { resData },
        } = resGetData;
        console.log(resData);
        setData(auxFormatData(resData));
        viewContent();
      }
    }
    try {
      loadData();
    } catch (error) {
      viewError();
    }
  }, []);

  const viewData = () => {
    return (
      <S.DivData>
        <NavTabsGeneral
          propContext={objData}
          propTabs={[
            {
              title: 'Info',
              component: <TabInfo propData={objData} propNewData={isNewData} />,
            },
            // !isNewData && {
            //   title: 'Images',
            //   component: <TabImage propData={objData} />,
            // },
            // !isNewData && {
            //   title: 'Medias',
            //   component: <TabMedia propData={objData} />,
            // },
          ]}
        />
      </S.DivData>
    );
  };

  const viewLoading = status => {
    if (status === undefined) {
      console.log('type A');
      setContent(false);
      setError(false);
      setLoading(true);
    } else {
      console.log('type B');
      setLoading(status);
    }
  };

  const viewError = () => {
    setContent(false);
    setLoading(false);
    setError(true);
  };

  const viewContent = () => {
    setLoading(false);
    setError(false);
    setContent(true);
  };

  return (
    <>
      <NavBar />
      <S.Container>
        <S.ContainerHeader>
          <S.Title>Plan</S.Title>
          <Line />
        </S.ContainerHeader>
        <S.ContainerContent>
          <PlanManagerContext.Provider
            value={{ viewLoading, viewError, viewContent }}
          >
            {isLoading && <Loader />}
            {isError && <Error />}
            {isContent && viewData()}
            {/* {isLoading ? <Loader /> : viewData()} */}
          </PlanManagerContext.Provider>
        </S.ContainerContent>
      </S.Container>
      <NotificationContainer />
    </>
  );
};

export default PlanManager;
